module.exports = __webpack_public_path__ + "static/media/circle-cropped.c18662d4.png";